var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"full-page-loading"}},[(_vm.loading)?_c('div',{staticClass:"full-page-loading"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }